import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock, Calendar } from 'lucide-react';
import { BlogPost as BlogPostType } from '../data/blogPosts';
interface Props {
  post: BlogPostType;
  onBack: () => void;
}
export function BlogPostPage({
  post,
  onBack
}: Props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <article className="min-h-screen bg-[#020611] pt-32 pb-24" data-id="element-48">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-49">
        <motion.button onClick={onBack} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 text-muted hover:text-accent transition-colors mb-12 group" data-id="element-50">
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-51" />
          Zurück zur Übersicht
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-52">
          <div className="flex items-center gap-4 text-sm text-muted mb-6 font-mono" data-id="element-53">
            <span className="flex items-center gap-1.5" data-id="element-54">
              <Calendar size={14} data-id="element-55" />
              {post.date}
            </span>
            <span className="w-1 h-1 rounded-full bg-border" data-id="element-56" />
            <span className="flex items-center gap-1.5" data-id="element-57">
              <Clock size={14} data-id="element-58" />
              {post.readTime} Lesezeit
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-heading font-bold leading-tight mb-8" data-id="element-59">
            {post.title}
          </h1>

          <p className="text-lg text-muted leading-relaxed mb-16 border-l-2 border-accent pl-6" data-id="element-60">
            {post.excerpt}
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-61">
          {post.sections.map((section, index) => <motion.section key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} data-id="element-62">
              <h2 className="text-xl md:text-2xl font-heading font-semibold mb-4 text-foreground" data-id="element-63">
                {section.heading}
              </h2>
              <p className="text-[#C0C0B8] leading-relaxed text-base" data-id="element-64">
                {section.body}
              </p>
            </motion.section>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-20 pt-12 border-t border-border" data-id="element-65">
          <div className="bg-surface border border-border p-8 text-center" data-id="element-66">
            <p className="text-lg font-heading mb-4" data-id="element-67">Interesse geweckt?</p>
            <p className="text-muted mb-6" data-id="element-68">
              Sprechen Sie mit unserem Team über Ihr Pilotprojekt.
            </p>
            <a href="mailto:info@pezula.net?subject=House%20Of%20AI" className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-[#020611] font-semibold px-6 py-3 transition-colors" data-id="element-69">
              info@pezula.net
            </a>
          </div>

          <button onClick={onBack} className="mt-8 inline-flex items-center gap-2 text-muted hover:text-accent transition-colors group" data-id="element-70">
            <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-71" />
            Alle Artikel anzeigen
          </button>
        </motion.div>
      </div>
    </article>;
}